import React, { PureComponent } from 'react'
import Partner from './Partner'
import styles from './styles'
import ghfmre from './ghfmre.png'
import ghnc from './ghnc.png'
import superadults from './super-adults.png'
import thinkfirst from './think-first.png'

export default class Benefits extends PureComponent {

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <Partner title={'SuperAdults'} src={superadults} />
          <Partner title={'GHNC'} src={ghnc} />
          <Partner title={'ThinkFirst'} src={thinkfirst} />
          <Partner title={'GHFMRE'} src={ghfmre} />
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Partners/Partners.js
 **/